import React, { memo } from "react"
import { ContinuousNode as ContinuousNodeType } from "@features/builder/graph/types"
import NodeContainer from "@features/builder/graph/nodes/NodeContainer"

export const ContinuousNode = memo((node: ContinuousNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container" title={node.data.expression || ""}>
        <div className="graph-node-type graph-node-continuous">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

ContinuousNode.displayName = "ContinuousNode"
